import { createWebHashHistory, createRouter } from "vue-router";

// ===== AUTH =====
import Login from "@/components/simi-auth/Login.vue";
import Register from "@/components/simi-auth/Register.vue";
import ResetPassword from "@/components/simi-auth/ResetPassword.vue";

// ===== LANDING =====
import LandingPage from "@/components/simi-landing/LandingPage.vue";

// ===== DASHBOARD =====
import Dashboard from "@/components/simi-dashboard/Dashboard.vue";

// ===== CAMPUS & OUTLETS =====
import CampusManagement from "@/components/simi-campus/CampusManagement.vue";
import DiningOutlets from "@/components/simi-campus/DiningOutlets.vue";
import UserManagement from "@/components/simi-campus/UserManagement.vue";

// ===== STUDENTS & ACADEMIC =====
import StudentManagement from "@/components/simi-students/StudentManagement.vue";
import ClassManagement from "@/components/simi-students/ClassManagement.vue";
import GradeEntry from "@/components/simi-students/GradeEntry.vue";
import Promotions from "@/components/simi-students/Promotions.vue";
import TermManagement from "@/components/simi-students/TermManagement.vue";
import StudentIdCards from "@/components/simi-students/StudentIdCards.vue";
import ParentsList from "@/components/simi-students/ParentsList.vue";

// ===== POS =====
import POSTerminal from "@/components/simi-pos/POSTerminal.vue";
import MenuManagement from "@/components/simi-pos/MenuManagement.vue";

// ===== WALLET =====
import WalletManagement from "@/components/simi-wallet/WalletManagement.vue";
import CashOut from "@/components/simi-wallet/CashOut.vue";
import SponsoredStudents from "@/components/simi-wallet/SponsoredStudents.vue";
import SponsorPortal from "@/components/simi-wallet/SponsorPortal.vue";

// ===== ATTENDANCE =====
import AttendanceDashboard from "@/components/simi-attendance/AttendanceDashboard.vue";
import TapPoints from "@/components/simi-attendance/TapPoints.vue";

// ===== FEES =====
import FeesDashboard from "@/components/simi-fees/FeesDashboard.vue";
import FeeStatement from "@/components/simi-fees/FeeStatement.vue";

// ===== SMS =====
import BulkSMS from "@/components/simi-sms/BulkSMS.vue";
import SMSCredits from "@/components/simi-sms/SMSCredits.vue";

// ===== DISCIPLINE =====
import DisciplineDashboard from "@/components/simi-discipline/DisciplineDashboard.vue";

// ===== CHORES =====
import ChoreManagement from "@/components/simi-chores/ChoreManagement.vue";

// ===== PARENT =====
import ParentDashboard from "@/components/simi-parent/ParentDashboard.vue";

// ===== PLATFORM ADMIN =====
import PlatformAdmin from "@/components/simi-admin/PlatformAdmin.vue";

// ===== SETTINGS =====
import SettingsPage from "@/components/simi-settings/SettingsPage.vue";
import NotificationSettings from "@/components/simi-settings/NotificationSettings.vue";
import PaymentManagement from "@/components/simi-payments/PaymentManagement.vue";
import MyPlatformInvoices from "@/components/simi-payments/MyPlatformInvoices.vue";
import SalesReport from "@/components/simi-payments/SalesReport.vue";
import LessonAttendance from "@/components/simi-attendance/LessonAttendance.vue";
import TimetableManager from "@/components/simi-attendance/TimetableManager.vue";
import StaffAttendance from "@/components/simi-attendance/StaffAttendance.vue";
import EventsManager from "@/components/simi-events/EventsManager.vue";
import FleetManagement from "@/components/simi-fleet/FleetManagement.vue";
import KitchenDisplay from "@/components/simi-kitchen/KitchenDisplay.vue";

// ===== PARENT PORTAL (public, token-based) =====
import ParentPortal from "@/components/simi-parent/ParentPortal.vue";
import BusTracker from "@/components/simi-parent/BusTracker.vue";

// ===== STUDENT PORTAL =====
import StudentPortal from "@/components/simi-students/StudentPortal.vue";




const routes = [
    // ===== PUBLIC ROUTES =====
    { path: "/", name: "landing", component: LandingPage, meta: { public: true } },
    { path: "/login", name: "login", component: Login, meta: { public: true } },
    { path: "/register", name: "register", component: Register, meta: { public: true } },
    { path: "/reset-password", name: "reset-password", component: ResetPassword, meta: { public: true } },
    { path: "/p/:token", name: "parent-portal", component: ParentPortal, meta: { public: true } },
    { path: "/bus/:busId", name: "bus-tracker", component: BusTracker, meta: { public: true } },
    { path: "/sponsor/:token", name: "sponsor-portal", component: SponsorPortal, meta: { public: true } },
    { path: "/parent-login", redirect: "/login" },

    // ===== DASHBOARD =====
    { path: "/dashboard", name: "dashboard", component: Dashboard, meta: { public: false } },

    // ===== STUDENT PORTAL =====
    { path: "/student-portal", name: "student-portal", component: StudentPortal, meta: { public: false } },

    // ===== CAMPUS & OUTLETS =====
    { path: "/campuses", name: "campuses", component: CampusManagement, meta: { public: false } },
    { path: "/dining-outlets", name: "dining-outlets", component: DiningOutlets, meta: { public: false } },
    { path: "/users", name: "users", component: UserManagement, meta: { public: false } },

    // ===== STUDENTS & ACADEMIC =====
    { path: "/students", name: "students", component: StudentManagement, meta: { public: false, menuKey: 'students' } },
    { path: "/parents", name: "parents", component: ParentsList, meta: { public: false, menuKey: 'students' } },
    { path: "/id-cards", name: "id-cards", component: StudentIdCards, meta: { public: false, menuKey: 'id-cards' } },
    { path: "/classes", name: "classes", component: ClassManagement, meta: { public: false, menuKey: 'classes' } },
    { path: "/grades", name: "grades", component: GradeEntry, meta: { public: false, menuKey: 'grades' } },
    { path: "/promotions", name: "promotions", component: Promotions, meta: { public: false, menuKey: 'promotions' } },
    { path: "/terms", name: "terms", component: TermManagement, meta: { public: false, menuKey: 'terms' } },

    // ===== POS =====
    { path: "/pos", name: "pos", component: POSTerminal, meta: { public: false, menuKey: 'pos' } },
    { path: "/menu", name: "menu", component: MenuManagement, meta: { public: false, menuKey: 'menu' } },

    // ===== WALLET =====
    { path: "/wallets", name: "wallets", component: WalletManagement, meta: { public: false, menuKey: 'wallets' } },
    { path: "/cash-out", name: "cash-out", component: CashOut, meta: { public: false, menuKey: 'cash-out' } },
    { path: "/sponsored-students", name: "sponsored-students", component: SponsoredStudents, meta: { public: false, menuKey: 'sponsored-students' } },

    // ===== ATTENDANCE =====
    { path: "/attendance", name: "attendance", component: AttendanceDashboard, meta: { public: false, menuKey: 'attendance' } },
    { path: "/buses", name: "buses", component: FleetManagement, meta: { public: false, menuKey: 'buses' } },
    { path: "/kitchen", name: "kitchen", component: KitchenDisplay, meta: { public: false, menuKey: 'kitchen' } },
    { path: "/tap-points", name: "tap-points", component: TapPoints, meta: { public: false, menuKey: 'tap-points' } },

    // ===== FEES =====
    { path: "/fees", name: "fees", component: FeesDashboard, meta: { public: false, menuKey: 'fees' } },
    { path: "/fees/statement/:studentId", name: "fee-statement", component: FeeStatement, meta: { public: false, menuKey: 'fees' } },

    // ===== SMS =====
    { path: "/sms", name: "sms", component: BulkSMS, meta: { public: false, menuKey: 'sms' } },
    { path: "/sms-credits", name: "sms-credits", component: SMSCredits, meta: { public: false, menuKey: 'sms-credits' } },

    // ===== DISCIPLINE =====
    { path: "/discipline", name: "discipline", component: DisciplineDashboard, meta: { public: false, menuKey: 'discipline' } },

    // ===== CHORES =====
    { path: "/chores", name: "chores", component: ChoreManagement, meta: { public: false, menuKey: 'chores' } },

    // ===== PARENT =====
    { path: "/my-children", name: "my-children", component: ParentDashboard, meta: { public: false, menuKey: 'my-children' } },

    // ===== PLATFORM ADMIN =====
    { path: "/admin", name: "admin", component: PlatformAdmin, meta: { public: false, menuKey: 'admin' } },

    // ===== SETTINGS =====
    { path: "/settings", name: "settings", component: SettingsPage, meta: { public: false, menuKey: 'settings' } },
    { path: "/notification-settings", name: "notification-settings", component: NotificationSettings, meta: { public: false, menuKey: 'settings' } },
    { path: "/payments", name: "payments", component: PaymentManagement, meta: { public: false, menuKey: 'payments' } },
    { path: "/sales-report", name: "sales-report", component: SalesReport, meta: { public: false, menuKey: 'sales-report' } },
    { path: "/billing/platform-invoices", name: "my-platform-invoices", component: MyPlatformInvoices, meta: { public: false } },
    { path: "/lesson-attendance", name: "lesson-attendance", component: LessonAttendance, meta: { public: false, menuKey: 'lesson-attendance' } },
    { path: "/timetable", name: "timetable", component: TimetableManager, meta: { public: false, menuKey: 'timetable' } },
    { path: "/staff-attendance", name: "staff-attendance", component: StaffAttendance, meta: { public: false, menuKey: 'staff-attendance' } },
    { path: "/events", name: "events", component: EventsManager, meta: { public: false, menuKey: 'events' } },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

// Auth guard
let userActivityTimer;

router.beforeEach((to, from, next) => {
    clearTimeout(userActivityTimer);

    if (!to.meta.public) {
        if (sessionStorage.getItem("isLoggedIn")) {
            const role = sessionStorage.getItem("userRole");

            // Students locked to their portal
            if (role === 'student' && to.path !== '/student-portal') {
                return next('/student-portal');
            }

            // Role-based menu access — block direct URL navigation to disallowed menus
            if (to.meta.menuKey) {
                let allowed = [];
                try { allowed = JSON.parse(sessionStorage.getItem('allowedMenus') || '[]'); } catch(e) { allowed = []; }
                // Empty array means no override fetched (backwards-compat) — allow through
                if (allowed.length > 0 && !allowed.includes(to.meta.menuKey)) {
                    // Send to dashboard or fallback if dashboard itself is blocked
                    const fallback = allowed.includes('dashboard') ? '/dashboard' : (allowed[0] ? '/' + allowed[0] : '/login');
                    return next(fallback);
                }
            }

            next();

            // 10 min inactivity timeout
            userActivityTimer = setTimeout(() => {
                sessionStorage.removeItem("isLoggedIn");
                router.push("/login");
            }, 10 * 60 * 1000);
        } else {
            next("/login");
        }
    } else {
        next();
    }
});

function handleUserActivity() {
    if (!sessionStorage.getItem("isLoggedIn")) return;
    clearTimeout(userActivityTimer);
    userActivityTimer = setTimeout(() => {
        sessionStorage.removeItem("isLoggedIn");
        router.push("/login");
    }, 10 * 60 * 1000);
}

document.addEventListener("mousemove", handleUserActivity);
document.addEventListener("keypress", handleUserActivity);

export default router;